import React, { useEffect, useRef } from 'react';

function Sidebar({
  portfolioData,
  conversations,
  currentConversationId,
  sidebarOpen,
  onLoadConversation,
  onStartNewConversation,
  onCloseSidebar
}) {
  const sections = portfolioData.sections;
  const closeRef = useRef(null);
  const drawerRef = useRef(null);

  useEffect(() => {
    if (!sidebarOpen) return undefined;
    const scrollY = window.scrollY;
    const previousBody = {
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };
    const previousRootOverflow = document.documentElement.style.overflow;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    closeRef.current?.focus();
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onCloseSidebar();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = drawerRef.current?.querySelectorAll('button:not([disabled])');
      if (!focusable?.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      Object.assign(document.body.style, previousBody);
      document.documentElement.style.overflow = previousRootOverflow;
      window.scrollTo(0, scrollY);
    };
  }, [sidebarOpen, onCloseSidebar]);

  return (
    <aside
      ref={drawerRef}
      id="portfolio-menu"
      className="utility-drawer"
      role="dialog"
      aria-modal="true"
      aria-label="Portfolio topics and conversation history"
      hidden={!sidebarOpen}
    >
      <button
        ref={closeRef}
        className="utility-drawer__close"
        onClick={onCloseSidebar}
        aria-label="Close navigation"
      >
        Close
      </button>
      <div className="utility-drawer__identity">
        <p className="eyebrow">Portfolio</p>
        <strong>{portfolioData.personal.name}</strong>
        <span>{portfolioData.personal.title}</span>
      </div>

      <div className="utility-drawer__content">
        {conversations.length > 0 && (
          <div className="conversation-history">
            <div>
              <h2>Recent questions</h2>
              {conversations.slice(-2).reverse().map((conversation) => (
                <button
                  key={conversation.id}
                  className={`conversation-item ${currentConversationId === conversation.id ? 'active' : ''}`}
                  onClick={() => onLoadConversation(conversation.id)}
                >
                  <span className="conversation-title">{conversation.title}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="topics-section">
          <h2>Browse topics</h2>
          <div className="topic-buttons">
            {Object.entries(sections).map(([key, section]) => (
              <button
                key={key}
                className="topic-button"
                onClick={() => onStartNewConversation(key)}
              >
                <span className="topic-text">{section.title}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
